import { render, staticRenderFns } from "./QuoteImageCategoryModal.vue?vue&type=template&id=5d996bc4&scoped=true"
import script from "./QuoteImageCategoryModal.vue?vue&type=script&lang=js"
export * from "./QuoteImageCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./QuoteImageCategoryModal.vue?vue&type=style&index=0&id=5d996bc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d996bc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d996bc4')) {
      api.createRecord('5d996bc4', component.options)
    } else {
      api.reload('5d996bc4', component.options)
    }
    module.hot.accept("./QuoteImageCategoryModal.vue?vue&type=template&id=5d996bc4&scoped=true", function () {
      api.rerender('5d996bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteImageCategoryModal.vue"
export default component.exports